import { emptySplitApi } from './stock/injectApi';

export const supplementaryApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    getPrimaryOffers: build.query({
      query: ({ size = 1000, providerId, eSim }) => ({ 
        url: `mno-product/product/`,
        method: 'GET',
        params: { size },
        headers: {
          'Provider-Id': providerId,
          Referrer: eSim, 
        },
      }),
      providesTags: ['Supplementary'],
    }),
    getSupplementaryOffers: build.query({
      query: ({ page = 0, size = 10, offerId = '', providerId, dataSim, eSim, primaryOfferId, title, asanImza }) => ({
        url: `mno-product/product/supplementary`,
        method: 'GET',
        params: { page, size, offerId, providerId, dataSim, primaryOfferId, title, asanImza },
        headers: {
          'Provider-Id': providerId,
          Referrer: eSim, 
        },
      }),
      providesTags: ['Supplementary'],
    }),
    getSupplementaryOfferById: build.query({
      query: ({ id, providerId, eSim }) => ({
        url: `mno-product/product/supplementary/${id}`,
        method: 'GET',
        headers: {
          'Provider-Id': providerId,
          Referrer: eSim,
        },
      }),
      providesTags: ['Supplementary'],
    }),
    createSupplementaryOffer: build.mutation({
      query: ({ eSim, ...data }) => ({ 
        url: `mno-product/product/supplementary`,
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'application/json',
          'Provider-Id': data.providerId,
          Referrer: eSim, 
        },
      }),
      invalidatesTags: ['Supplementary'],
    }),
    updateSupplementaryOffer: build.mutation({
      query: ({ id, eSim, ...data }) => ({ 
        url: `mno-product/product/supplementary/${id}`,
        method: 'PUT',
        data,
        headers: {
          'Provider-Id': data.providerId,
          Referrer: eSim, 
        },
      }),
      invalidatesTags: ['Supplementary'],
    }),
    deleteSupplementaryOffer: build.mutation({
      query: (id) => ({
        url: `mno-product/product/supplementary/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Supplementary'],
    }),
  }),
});

export const {
  useGetPrimaryOffersQuery,
  useGetSupplementaryOffersQuery,
  useLazyGetSupplementaryOfferByIdQuery,
  useCreateSupplementaryOfferMutation,
  useUpdateSupplementaryOfferMutation,
  useDeleteSupplementaryOfferMutation,
} = supplementaryApi;
